import { render } from "./WCStoreLabel.vue?vue&type=template&id=69e7ba7a&scoped=true&ts=true"
import script from "./WCStoreLabel.vue?vue&type=script&lang=ts"
export * from "./WCStoreLabel.vue?vue&type=script&lang=ts"

import "./WCStoreLabel.vue?vue&type=style&index=0&id=69e7ba7a&scoped=true&lang=scss"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-69e7ba7a"]])

export default __exports__